import { render, staticRenderFns } from "./PanelCompetitionCycle.vue?vue&type=template&id=0ad4c7c3&scoped=true&"
import script from "./PanelCompetitionCycle.vue?vue&type=script&lang=js&"
export * from "./PanelCompetitionCycle.vue?vue&type=script&lang=js&"
import style0 from "./PanelCompetitionCycle.vue?vue&type=style&index=0&id=0ad4c7c3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ad4c7c3",
  null
  
)

export default component.exports